export default __webpack_public_path__ + "static/media/cp_geo_kp.9fd3021e.svg";